import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import SponsorsFormContainer from '../../../../Containers/AdminContainer/Sponsors/SponsorsForm';
const SponsorsFormScreen = () => {
  return <SponsorsFormContainer />;
};

export default SponsorsFormScreen;
